<template>
  <div class="apply-notify">
    <div
      class="apply-notify-inbox flex-align__between primary"
    >
      <h2>{{ title }}</h2>
      <div>
        <div v-if="isActive && applyEndTime" class="apply-notify-item">
          <span class="apply-notify-item__label">剩余：</span>
          <span v-if="applyTimeLeft" class="apply-notify-item__content">
            {{ applyTimeLeft }}
          </span>
          <span
            v-if="applyStartTime && applyEndTime"
            class="apply-notify-item__content"
          >
            <strong>{{ day }}</strong> 天 <strong>{{ hours }}</strong> 时
            <strong>{{ minutes }}</strong> 分 <strong>{{ seconds }}</strong> 秒
          </span>
        </div>
        <div v-else-if="applyEndTime" class="apply-notify-item">
          <span class="apply-notify-item__content end">{{ label }}已截止</span>
        </div>
        <div v-if="applyEndTime" class="apply-notify-item">
          <span class="apply-notify-item__label">{{ label }}截止时间：</span>
          <span class="apply-notify-item__content">{{ endTime }}</span>
        </div>
        <div v-else-if="!applyEndTime" class="apply-notify-item">
          <span class="apply-notify-item__content">长期有效</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateUtils from '@/utils/date'

export default {
  name: 'ApplyNotify',

  props: {
    // 项目名称
    title: {
      type: String,
      default: ''
    },

    // 关键名称
    label: {
      type: String,
      default: ''
    },

    // 报名中
    active: {
      type: Boolean,
      default: true
    },

    // 报名开始时间
    applyStartTime: {
      type: String,
      default: ''
    },

    // 报名截止时间，例如：2020年09月17日 15:00:00
    applyEndTime: {
      type: String,
      default: '',
      required: true
    },

    // 报名剩余时间，例如1天3小时10分钟
    applyTimeLeft: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      dateUtils: new DateUtils(), // 倒计时操作的类实例化
      timeLeftMillisecond: 0, // 倒计时的毫秒

      day: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  },

  computed: {
    endTime() {
      return DateUtils.format(this.applyEndTime, 'yyyy年MM月dd日 HH:mm')
    },

    isActive() {
      return this.timeLeftMillisecond > 0
    }
  },

  watch: {
    applyEndTime(newVal) {
      if (newVal) {
        this.getCountDownTime()
      }
    },

    applyStartTime(newVal) {
      if (newVal) {
        this.getCountDownTime()
      }
    },

    timeLeftMillisecond(val) {
      const { days, hours, minutes, seconds } = DateUtils.formatDuring(val)

      this.day = days
      this.hours = hours
      this.minutes = minutes
      this.seconds = Math.floor(seconds)
    }
  },

  created() {
    if (!this.applyTimeLeft) {
      this.getCountDownTime()
    }
  },

  beforeDestroy() {
    this.dateUtils.stopCountDown()
  },

  methods: {
    getCountDownTime() {
      if (!this.applyStartTime || !this.applyEndTime) {
        this.dateUtils.stopCountDown()
        return
      }

      this.dateUtils.countTimeDown(
        this.applyStartTime || 0,
        this.applyEndTime || 0,
        ms => {
          this.timeLeftMillisecond = ms
          if (ms === 0) this.$emit('stop')
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-bottom: 0px;
}
.apply-notify {
  background-color: $white-background-color;
  padding: 6px;
  border-radius: 4px;
  margin-bottom: 16px;

  .apply-notify-inbox {
    padding: 10px 18px;
    h2 {
      font-size: 24px;
    }
    .apply-notify-item {
      text-align: right;
      .apply-notify-item__label {
        color: $third-text-color;
        font-size: 14px;
      }
      .apply-notify-item__content {
        color: $text-color;
        font-size: 14px;
        strong {
          font-size: 24px;
          color: $primary-color;
          padding: 0 4px;
        }
        &.end {
          font-size: 20px;
          color: $primary-color;
        }
      }
      & + .apply-notify-item {
        margin-top: 8px;
      }
    }

    &.primary {
      background-color: $primary-fourth-color;
    }
  }
}
</style>
